import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { BOOKING_CALENDAR_PACKAGES } from '../../../../brands/default/content/components/deal';
import CustomNativeSelect from '../../../_generic/custom-native-select/CustomNativeSelect';
import Spinner from '../../../_generic/spinner/Spinner';
import BookingCalendarButton from './BookingCalendarButton';
import BookingCalendarPackage from './BookingCalendarPackage';

const BookingCalendarPackages = ({
  currency,
  isDynamicTravelGift,
  onSelect,
  onQuantityChange,
  packages,
  quantity,
  resetPackage,
  selection,
}) => {
  const [selectedPackage, setSelectedPackage] = useState(null);
  const MAX_PILL_BUTTONS = 3;
  const { bcorStepOne } = BOOKING_CALENDAR_PACKAGES;
  const selectPackage = (packageToSelect) => {
    setSelectedPackage(packageToSelect);
  };

  const selectPackageDropDown = (stringifyPackage) => {
    const packageToSelect = JSON.parse(stringifyPackage);
    if (packageToSelect?.calendarProductView[0]?.productAvailable) {
      onSelect(packageToSelect?.calendarProductView[0]);
    }
    setSelectedPackage(packageToSelect);
  };

  useEffect(() => {
    if (packages.length > 0) {
      // select the first package
      const newPackage = packages[0];
      setSelectedPackage(newPackage);
    }
  }, [packages, resetPackage]);

  if (packages.length === 0 || !selectedPackage) {
    return (
      <>
        <div className="booking-calendar--loading">
          <Spinner />
        </div>
        <style jsx>{`
          .booking-calendar--loading {
            position: relative;
            min-height: 300px;
          }
        `}</style>
      </>
    );
  }

  return (
    <>
      <div className="packages">
        {packages.length <= MAX_PILL_BUTTONS && (
          <div className="package-buttons">
            {packages?.map((item) => {
              return (
                <BookingCalendarButton
                  className={
                    selectedPackage.calendarProductView[0]
                      .dealVoucherProductId ===
                    item.calendarProductView[0].dealVoucherProductId
                      ? 'package-button package-button-selected'
                      : 'package-button package-button-unselected'
                  }
                  isActive={
                    selectedPackage.calendarProductView[0]
                      .dealVoucherProductId ===
                    item.calendarProductView[0].dealVoucherProductId
                  }
                  key={item.roomType}
                  onClick={() => {
                    selectPackage(item);
                    if (item?.calendarProductView[0]?.productAvailable) {
                      onSelect(item?.calendarProductView[0]);
                    }
                  }}
                  text={item.roomType}
                />
              );
            })}
          </div>
        )}
        {packages.length > MAX_PILL_BUTTONS && (
          <div className="package-drop-down">
            <CustomNativeSelect
              ariaLabel={bcorStepOne}
              /* eslint-disable-next-line react/forbid-component-props */
              className="full-width margin"
              id="num-nights"
              isLarge
              onChange={(event) => selectPackageDropDown(event.target.value)}
              value={JSON.stringify(selectedPackage)}
            >
              {packages?.map((item) => {
                return (
                  <option key={item.roomType} value={JSON.stringify(item)}>
                    {item.roomType}
                  </option>
                );
              })}
            </CustomNativeSelect>
          </div>
        )}
        {selectedPackage?.calendarProductView?.map((product) => (
          <BookingCalendarPackage
            currency={currency}
            isDynamicTravelGift={isDynamicTravelGift}
            key={product.dealVoucherProductId}
            onQuantityChange={onQuantityChange}
            onSelect={onSelect}
            product={product}
            quantity={quantity}
            selected={
              selection?.dealVoucherProductId === product.dealVoucherProductId
            }
          />
        ))}
      </div>
      <style jsx>{`
        .packages {
          margin-bottom: 20px;
        }
        .package-buttons {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
          margin-bottom: 15px;
        }
        .package-drop-down {
          margin-bottom: 15px;
        }
      `}</style>
    </>
  );
};

BookingCalendarPackages.propTypes = {
  currency: PropTypes.string,
  isDynamicTravelGift: PropTypes.bool,
  onQuantityChange: PropTypes.func,
  onSelect: PropTypes.func,
  packages: PropTypes.array,
  quantity: PropTypes.number,
  resetPackage: PropTypes.string,
  selection: PropTypes.object,
};

BookingCalendarPackages.defaultProps = {
  currency: 'gbp',
  isDynamicTravelGift: false,
  onQuantityChange: () => false,
  onSelect: () => false,
  packages: [],
  quantity: 1,
  selection: null,
};

export default BookingCalendarPackages;
